import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderResults2026() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 3500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    '@0.75': {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    '@1.00': {
                        slidesPerView: 4,
                        spaceBetween: 30,
                    },
                    '@1.50': {
                        slidesPerView: 4,
                        spaceBetween: 30,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >
                <div className="center">
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/images/2025/Class Nursery.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                            <div className="overlay-text">
                                <a href="assets/images/2025/Class Nursery.webp" data-fancybox="gallery">
                                    <i className="fa fa-plus fa-2x" />
                                </a>
                                <h5 className="fw-bold">Result</h5>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/images/2025/Class LKG.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                            <div className="overlay-text">
                                <a href="assets/images/2025/Class LKG.webp" data-fancybox="gallery">
                                    <i className="fa fa-plus fa-2x" />
                                </a>
                                <h5 className="fw-bold">Result</h5>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/images/2025/Class UKG.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                            <div className="overlay-text">
                                <a href="assets/images/2025/Class UKG.webp" data-fancybox="gallery">
                                    <i className="fa fa-plus fa-2x" />
                                </a>
                                <h5 className="fw-bold">Result</h5>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/images/2025/Class 1st.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                            <div className="overlay-text">
                                <a href="assets/images/2025/Class 1st.webp" data-fancybox="gallery">
                                    <i className="fa fa-plus fa-2x" />
                                </a>
                                <h5 className="fw-bold">Result</h5>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/images/2025/Class 2nd.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                            <div className="overlay-text">
                                <a href="assets/images/2025/Class 2nd.webp" data-fancybox="gallery">
                                    <i className="fa fa-plus fa-2x" />
                                </a>
                                <h5 className="fw-bold">Result</h5>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/images/2025/Class 3rd.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                            <div className="overlay-text">
                                <a href="assets/images/2025/Class 3rd.webp" data-fancybox="gallery">
                                    <i className="fa fa-plus fa-2x" />
                                </a>
                                <h5 className="fw-bold">Result</h5>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/images/2025/Class 4th.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                            <div className="overlay-text">
                                <a href="assets/images/2025/Class 4th.webp" data-fancybox="gallery">
                                    <i className="fa fa-plus fa-2x" />
                                </a>
                                <h5 className="fw-bold">Result</h5>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/images/2025/Class 6th.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                            <div className="overlay-text">
                                <a href="assets/images/2025/Class 6th.webp" data-fancybox="gallery">
                                    <i className="fa fa-plus fa-2x" />
                                </a>
                                <h5 className="fw-bold">Result</h5>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/images/2025/Class 7th.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                            <div className="overlay-text">
                                <a href="assets/images/2025/Class 7th.webp" data-fancybox="gallery">
                                    <i className="fa fa-plus fa-2x" />
                                </a>
                                <h5 className="fw-bold">Result</h5>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/images/2025/Class 9th.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                            <div className="overlay-text">
                                <a href="assets/images/2025/Class 9th.webp" data-fancybox="gallery">
                                    <i className="fa fa-plus fa-2x" />
                                </a>
                                <h5 className="fw-bold">Result</h5>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/images/2025/Class 11th.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                            <div className="overlay-text">
                                <a href="assets/images/2025/Class 11th.webp" data-fancybox="gallery">
                                    <i className="fa fa-plus fa-2x" />
                                </a>
                                <h5 className="fw-bold">Result</h5>
                            </div>
                        </div>
                    </SwiperSlide>


                </div>
            </Swiper>
        </>
    );
}
